"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styles = require("../../../styles");

var styles = {
  root: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    height: '35px',
    padding: '0 15px',
    cursor: 'pointer',
    '&:hover': {
      background: _styles.colors.blue,
      color: 'white',
      fill: 'white'
    }
  },
  active: {
    background: _styles.colors.blue,
    color: 'white',
    fill: 'white'
  }
};
var _default = styles;
exports["default"] = _default;